import React from "react";
import { TermsConditionComponent } from "@hedgefund/shared";

const TermsAndConditions = () => {
  return <TermsConditionComponent />;
};

export default TermsAndConditions;
